import {Booking} from "@/classes/viewmodels/Booking";
import ValidatedField from "@/classes/global/ValidatedField";

export default class PreJobAirBooking extends Booking {

    constructor() {

        super();

        this.flightShipment = {

            placeOfReceipt: '',
            placeOfReceiptId: '',
            originPort: '',
            originPortId: '',
            destinationPort: '',
            destinationPortId: '',
            finalDestination: '',
            finalDestinationId: '',
            awbMaster: '',
            ucrNumber: '',
            hawb: '',
            directFlight: false,
            departingFlightNumber: '',
            arrivingFlightNumber: '',
            customerRef: '',
            serviceType: '',
            terms: '',
            shipmentValue: '',
            currency: '',
            commodity: '',
            remarks: '',
            estimatedPickupDate: '',
            actualPickupDate: '',
            estimatedPickupTime: '',
            actualPickupTime: '',
            estimatedDepartureDate: '',
            actualDepartureDate: '',
            estimatedDepartureTime: '',
            actualDepartureTime: '',
            estimatedArrivalDate: '',
            actualArrivalDate: '',
            estimatedArrivalTime: '',
            actualArrivalTime: '',
            estimatedDeliveryDate: '',
            actualDeliveryDate: '',
            estimatedDeliveryTime: '',
            actualDeliveryTime: ''

        }

        this.tileSelection = {

            shipper: true,
            consignee: false,
            flightShipment: false,
            dimensions: false,
            documents: false
        }

        this.tileValidation = {

            shipper: true,
            consignee: true,
            flightShipment: true,
            dimensions: true
        }

        this.metaData = {

            shippers: [],
            consignees: [],
            packageTypes: [],
            serviceTypes: [],
            currencies: [],
            billingParties: [],
            countries: [],
            validatedFields: []

        }

        this.tempValidFields =  [

            new ValidatedField('shipperName', true, true, 'Shipper Name'),
            // new ValidatedField('shipperRef', true, true, 'Shipper Reference'),
            new ValidatedField('shipperAddressLine1', true, true, 'Shipper AddressLine 1'),
            // new ValidatedField('shipperAddressLine2', true, false, 'Shipper AddressLine 2'),
            // new ValidatedField('shipperCity', true, false, 'Shipper City'),
            // new ValidatedField('shipperCounty', true, false, 'Shipper County'),
            // new ValidatedField('shipperPostcode', true, false, 'Shipper Postcode'),
            // new ValidatedField('shipperCountry', true, false, 'Shipper Country'),
            // new ValidatedField('shipperVatNumber', true, false, 'Shipper VAT Number'),
            // new ValidatedField('shipperContactFullName', true, false, 'Shipper Contact Selection'),
            // new ValidatedField('shipperContactTitle', true, false, 'Shipper Contact Title'),
            // new ValidatedField('shipperContactFirstName', true, false, 'Shipper Contact First Name'),
            // new ValidatedField('shipperContactLastName', true, false, 'Shipper Contact Last Name'),
            // new ValidatedField('shipperContactPhone', true, false, 'Shipper Contact Telephone'),
            // new ValidatedField('shipperContactEmail', true, false, 'Shipper Contact Email'),
            // new ValidatedField('shipperContactDepartment', true, false, 'Shipper Contact Department'),
            // new ValidatedField('consigneeName', true, false, 'Consignee Name'),
            // new ValidatedField('consigneeAddressLine1', true, false, 'Consignee AddressLine 1'),
            // new ValidatedField('consigneeAddressLine2', true, false, 'Consignee AddressLine 2'),
            // new ValidatedField('consigneeCity', true, false, 'Consignee City'),
            // new ValidatedField('consigneeCounty', true, false, 'Consignee County'),
            // new ValidatedField('consigneePostcode', true, false, 'Consignee Postcode'),
            // new ValidatedField('consigneeCountry', true, false, 'Consignee Country'),
            // new ValidatedField('consigneeVatNumber', true, false, 'Consignee VAT Number'),
            // new ValidatedField('consigneeContactFullName', true, false, 'Consignee Contact Selection'),
            // new ValidatedField('consigneeContactTitle', true, false, 'Consignee Contact Title'),
            // new ValidatedField('consigneeContactFirstName', true, false, 'Consignee Contact First Name'),
            // new ValidatedField('consigneeContactLastName', true, false, 'Consignee Contact Last Name'),
            // new ValidatedField('consigneeContactPhone', true, false, 'Consignee Contact Phone'),
            // new ValidatedField('consigneeContactEmail', true, false, 'Consignee Contact Email'),
            // new ValidatedField('consigneeRef', true, false, 'Consignee Reference'),
            // new ValidatedField('additionalRef', true, false, 'Consignee Additional Reference'),
            // new ValidatedField('placeOfReceipt', true, false, 'Place Of Receipt'),
            // new ValidatedField('originPort', true, false, 'Origin Port'),
            // new ValidatedField('destinationPort', true, false, 'Destination Port'),
            // new ValidatedField('finalDestination', true, false, 'Final Destination'),
            // new ValidatedField('awbMaster', true, false, 'AWB Master'),
            // new ValidatedField('ucrNumber', true, false, 'UCR Number'),
            // new ValidatedField('hawb', true, false, 'HAWB Number'),
            // new ValidatedField('departingFlightNumber', true, false, 'Departing Flight Number'),
            // new ValidatedField('arrivingFlightNumber', true, false, 'Arriving Flight Number'),
            // new ValidatedField('customerRef', true, false, 'Customer Reference'),
            // new ValidatedField('terms', true, false, 'Terms Of Shipment'),
            // new ValidatedField('serviceType', true, false, 'Service Type'),
            // new ValidatedField('remarks', true, false, 'Additional Remarks'),
            // new ValidatedField('pieces', true, false, 'Dims Pieces'),
            // new ValidatedField('length', true, false, 'Dims Length'),
            // new ValidatedField('width', true, false, 'Dims Width'),
            // new ValidatedField('height', true, false, 'Dims Height'),
            // new ValidatedField('weight', true, false, 'Dims Weight'),
            // new ValidatedField('packaging', false, false, 'Dims Packaging'),
            // new ValidatedField('totalPieces', true, false, 'Dims Total Pieces'),
            // new ValidatedField('totalWeight', true, false, 'Dims Total Weight'),
            // new ValidatedField('shipmentValue', true, false, 'Shipment Value'),
            // new ValidatedField('currency', true, false, 'Shipment Currency'),
            // new ValidatedField('commodity', true, false, 'Shipment Commodity'),
            // new ValidatedField('estimatedPickupDate', true, false, 'Pickup Date'),
            // new ValidatedField('estimatedPickupTime', true, false, 'Pickup Time'),
            // new ValidatedField('estimatedDepartureDate', true, false, 'Departure Date'),
            // new ValidatedField('estimatedDepartureTime', true, false, 'Departure Time'),
            // new ValidatedField('estimatedArrivalDate', true, false, 'Arrival Date'),
            // new ValidatedField('estimatedArrivalTime', true, false, 'Arrival Time'),
            // new ValidatedField('estimatedDeliveryDate', true, false, 'Delivery Date'),
            // new ValidatedField('estimatedDeliveryTime', true, false, 'Delivery Time'),

        ]

    }
}
